import { useState } from "react";
import {
  Flex,
  Box,
  Heading,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  VStack,
  SimpleGrid,
  Button,
} from "@chakra-ui/react";
import { memo } from "react";
import Animated from "./AnimatedSection";
import { useNavigate } from "react-router-dom";

export const eventData = {
  "North Cyprus": [
    {
      date: "May 17th-18th",
      time: "9 AM - 6 AM",
      eventName: "INTERNATIONAL IDEATORS CUP (IIC) Regional Round",
      contactNumber: "888-512-2168",
      venue: "CYPRUS AYDIN UNIVERSITY",
    },
  ],
};

const EventCard = memo(({ event }) => {
  const nav = useNavigate();
  const eventDetails = [
    { label: "Date", value: event.date },
    { label: "Time", value: event.time },
    { label: "Event Name", value: event.eventName },
    { label: "Contact Number", value: event.contactNumber },
    { label: "Venue", value: event.venue },
  ];

  const formUrl =
    "https://forms.zohopublic.com/IDEATORSCUP/form/CYPRUSROUNDREGISTRATION/formperma/Tyx16DXRUfRvZhmvGzZIq3-AiDXmFma208KpF8Ib9S4";

  const handleRegisterClick = () => {
    window.open(formUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Flex
      bg="white"
      p={4}
      borderRadius="16px"
      justify="space-between"
      align={{ base: "normal", lg: "center" }}
      shadow="md"
      flexDirection={{ base: "column", lg: "row" }}
      _hover={{ bg: "brand.150", color: "white" }}
      role="group"
    >
      <SimpleGrid columns={{ base: 2, md: 5 }} spacing={4} w="100%">
        {eventDetails.map((detail, index) => (
          <Box key={index}>
            <Text fontSize={{ base: "14px", lg: "16px" }} fontWeight="700">
              {detail.label}
            </Text>
            <Text
            w={{base:'100%',lg:'80%'}}
              fontSize={{ base: "14px", lg: "16px" }}
              mt={{ base: 1, lg: 2 }}
              fontWeight="700"
            >
              {detail.value}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      <Button
        bg="brand.150"
        overflowX={{ base: "auto", md: "unset" }}
        color="white"
        mt={{ base: 2, lg: 0 }}
        onClick={handleRegisterClick}
        _groupHover={{ bg: "black" }}
      >
        Register Now
      </Button>
    </Flex>
  );
});

export default function TabScheduleSection() {
  const countries = [
    "North Cyprus",
    "Malaysia",
    "Thailand",
    "Azerbaijan",
    "USA",
    "Pakistan",
  ];
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Animated>
      <Flex
        id="mission"
        m="auto"
        w="90%"
        mt={{ base: 6, lg: 0 }}
        bg="brand.200"
        borderRadius={{ base: "24px", lg: "42px" }}
        py={{ base: 6, lg: 12 }}
        justifyContent="center"
        direction="column"
      >
        <Box textAlign="center" w="100%">
          <Heading color="black" fontSize={{ base: "26px", lg: "42px" }}>
            UPCOMING EVENTS
          </Heading>
          <Text mt={2} w="90%" mx="auto">
            From ideation to creation. Coming to your city, very soon.
          </Text>
        </Box>

        <Tabs
          w="90%"
          variant="unstyled"
          index={selectedTab}
          onChange={(index) => setSelectedTab(index)}
          m="auto"
        >
          <TabList
            my={{ base: 6, xl: 12 }}
            display="grid"
            gridTemplateColumns={{
              base: "repeat(auto-fit, minmax(100px, 1fr))",
              md: "repeat(3, 1fr)",
              lg: "repeat(6, 1fr)",
            }}
            gap={4}
            justifyContent="center"
            mx="auto"
          >
            {countries.map((country, index) => (
              <Tab
                key={index}
                fontWeight="700"
                textAlign="center"
                _selected={{
                  bg: "brand.150",
                  color: "white",
                  borderRadius: "12px",
                }}
                p={3}
              >
                {country}
              </Tab>
            ))}
          </TabList>

          <Animated>
            <TabPanels>
              {countries.map((country, index) => (
                <TabPanel key={index} p={0}>
                  <VStack spacing={6} align="stretch">
                    {eventData[country] ? (
                      eventData[country].map((event, i) => (
                        <EventCard key={i} event={event} />
                      ))
                    ) : (
                      <Text fontSize="lg" fontWeight="bold" textAlign="center">
                        Coming Soon
                      </Text>
                    )}
                  </VStack>
                </TabPanel>
              ))}
            </TabPanels>
          </Animated>
        </Tabs>
      </Flex>
    </Animated>
  );
}
